import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProductBasedCollectionPageWrapper } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/__internal__/ProductBasedCollectionPageWrapper";
import { DESKTOP_COLUMN_COUNT, MOBILE_COLUMN_COUNT, TABLET_COLUMN_COUNT } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/__internal__/utils";
import { PBCEfficientBuyingItemList } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/CollectionDiscovery/PBCEfficientBuyingItemList";
import { CollectionHeader } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/CollectionHeader";
import { OtherProductBasedCollections } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/OtherProductBasedCollections";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import * as React from "react";
import styled from "styled-components";
export var ProductBasedCollectionPageContent = function(param) {
    var collection = param.collection, productTiles = param.productTiles, otherCollections = param.otherCollections, showVerticalImagery = param.showVerticalImagery, collectionPromo = param.collectionPromo;
    var gridGap = useResponsiveValue({
        mobileAndAbove: 8,
        tabletAndAbove: 16
    });
    var columnCount = useResponsiveValue({
        mobileAndAbove: MOBILE_COLUMN_COUNT,
        tabletAndAbove: TABLET_COLUMN_COUNT,
        desktopAndAbove: DESKTOP_COLUMN_COUNT
    });
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: 0,
                    tabletAndAbove: "6x"
                }
            }),
            /*#__PURE__*/ _jsxs(ProductBasedCollectionPageWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(CollectionHeader, {
                        collection: collection,
                        collectionPromo: collectionPromo
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "5x"
                    }),
                    /*#__PURE__*/ _jsx(StyledColumn, {
                        children: /*#__PURE__*/ _jsx(PBCEfficientBuyingItemList, {
                            collection: collection,
                            productTiles: productTiles,
                            showVerticalImagery: showVerticalImagery,
                            columnCount: columnCount,
                            gridGap: gridGap,
                            collectionPromo: collectionPromo
                        })
                    }),
                    otherCollections.length ? /*#__PURE__*/ _jsxs(StyledColumn, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: {
                                    mobileAndAbove: "5x",
                                    desktopAndAbove: "6x"
                                }
                            }),
                            /*#__PURE__*/ _jsx(OtherProductBasedCollections, {
                                collection: collection,
                                otherCollections: otherCollections,
                                columnCount: columnCount,
                                gridGap: gridGap
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "5x",
                            desktopAndAbove: "6x"
                        }
                    })
                ]
            })
        ]
    });
};
var StyledColumn = styled(Column).withConfig({
    componentId: "sc-8add80d8-0"
})([
    "",
    "{padding:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(0, "2x"));
